export type IcHeroContentAlignments = "left" | "center";
